import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table,Form, Button } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../services/resales-request';
import {maskDocument, documentType, maskZip} from 'helpers/document';
import { useParams } from 'react-router-dom';
import { setContext } from 'redux-saga/effects';

const AddressForm = (params) => {
  const [reports, setReports] = useState(params.reports);
  const [company, setCompany] = useState([]);
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})


  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [wasModified, setWasModified] = useState(false);

  useEffect(() => {
    setCompany(reports.data[0]);
    if(reports.data[0] != null && formChanges == null){
      setFormChanges({ ...reports.data[0] });
    }
  }, [reports,formEdit,wasModified,formChanges,erroRequired]);

  const verificarAlteracoes = (value,attributeName) => {
    const index = erroRequired.campos.indexOf(attributeName);
    if (index > -1) {
      erroRequired.campos.splice(index, 1);
    }
    var changes = { ...formChanges };
    changes[attributeName] = value;
    
    var retorno = false;
    Object.keys(company).map((v)=>{
      var v1 = company[v]?company[v]:'';
      var v2 = changes[v]?changes[v]:'';
      if(v2 !== v1){
        retorno = true;
      }
    })
    setWasModified(retorno);
    setFormChanges(changes);
  };

  const saveCompany = ()=>{
    let camposObrigatorios = [];
    let required = {campos:[],erro:false};
    camposObrigatorios.map(v=>{
      if(formChanges[v] == null || formChanges[v] == "" || formChanges[v] == 0){
        required.campos.push(v);
        required.erro = true;
      }
    });
    setErroRequired(required);
    if(!required.erro){
      formChanges.area = 'anddress';
      let company = ResalesRequestService.saveResale(localStorage.getItem('companyId'),{ params: { ...formChanges } });
      company
      .then(data => {
        setReports(data);
        setFormEdit(false);
        setWasModified(false);
      });
    }
  };

  const getValue = (attributeName)=>{
    if(!formEdit){
      return company[attributeName]?company[attributeName]:'';
    } else {
      return formChanges[attributeName]?formChanges[attributeName]:'';
    }
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Container>
            <Row className="mb-4">
              <Col>
                <p className="font-weight-bold">Endereço</p>
              </Col>
              <Col className="d-flex justify-content-end">
                {formEdit?(
                <>
                  <Button style={{marginRight:"5px"}}
                    className={"btn-xs btn-edit"}
                    size="sm"
                    variant="success"
                    disabled={!wasModified}
                    title={!wasModified?'Não houve alterações':''}
                    onClick={()=>{
                      saveCompany();
                    }}>Salvar</Button>
                  <Button style={{marginRight:"5px"}}
                    className={"btn-xs btn-edit"}
                    size="sm"
                    variant="danger"
                    onClick={()=>{
                      setFormEdit(false);
                      setFormChanges({ ...reports.data[0] });
                      setErroRequired({campos:[],erro:false})
                    }}>Cancelar</Button>
                </>
                ):(<></>)}
                <Button
                  size="sm"
                  disabled={formEdit}
                  onClick={()=>{
                  setFormEdit(true);
                }}>{formEdit?'Editando':'Editar'}</Button>
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <Form.Group>
                  <Form.Label>CEP:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_zipcode')}
                    value={getValue('address_zipcode')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={7}>
                <Form.Group>
                  <Form.Label>Endereço:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address')}
                    value={getValue('address')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Form.Group>
                  <Form.Label>Nº:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_number')}
                    value={getValue('address_number')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group>
                  <Form.Label>Estado:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_state')}
                    value={company.address_state}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group>
                  <Form.Label>Cidade:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_city')}
                    value={getValue('address_city')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group>
                  <Form.Label>Bairro:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_neighborhood')}
                    value={getValue('address_neighborhood')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group>
                  <Form.Label>Complemento:</Form.Label>
                  <Form.Control
                    as="input"
                    disabled={!formEdit}
                    onChange={e=>verificarAlteracoes(e.target.value,'address_complement')}
                    value={getValue('address_complement')}
                    >
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default AddressForm;